import { defineSagaForService } from '@repo/core'
import { getConvenienceTestQuestionnaire } from '@repo/user-services'
import { convenienceTestQuestionnaireActions } from '../../slices'

export const convenienceTestQuestionnaireServiceConfig = defineSagaForService({
  [convenienceTestQuestionnaireActions.getRequest.type]: {
    apiClientDomain: 'user',
    service: getConvenienceTestQuestionnaire,
    actionTypeResponse: convenienceTestQuestionnaireActions.getResponse.type,
    actionTypeRequest: convenienceTestQuestionnaireActions.getRequest.type,
  },
  [convenienceTestQuestionnaireActions.refreshRequest.type]: {
    apiClientDomain: 'user',
    service: getConvenienceTestQuestionnaire,
    actionTypeResponse: convenienceTestQuestionnaireActions.refreshResponse.type,
    actionTypeRequest: convenienceTestQuestionnaireActions.refreshRequest.type,
  },
})
